import api from "../../../utils/useApi";
import { mock_calender } from "../../../utils/useMockData";

const BasketLoadCalendar = async (
  setValue,
  location,
  setDateTime,
  dateTime
) => {
  try {
    const { data } = await api.get(`/calendars?location=${location}`);

    const dataCalender = data?.calendars;
    // const dataCalender = mock_calender;

    if (dateTime?.pick_up_date) {
      const findDate = dataCalender?.find(
        (row) => row?.showDate === dateTime?.pick_up_date?.date
      );
      if (findDate?.status) {
        setDateTime((prev) => ({
          ...prev,
          pick_up_date: "",
        }));
      }
    }
    if (dateTime?.return_date) {
      const findDate = dataCalender?.find(
        (row) => row?.showDate === dateTime?.return_date?.date
      );
      if (findDate?.status) {
        setDateTime((prev) => ({
          ...prev,
          return_date: "",
        }));
      }
      // console.log("dateTime", {
      //   dateTime,
      //   data: dataCalender,
      //   findDate,
      // });
    }
    setValue(dataCalender);
    // setValue(mock_calender);
  } catch (error) {
    console.error("BasketLoadCalendar", error);
  }
};

export default BasketLoadCalendar;
